document.addEventListener("DOMContentLoaded", () => {
  gsap.registerPlugin(SplitText);

  // Title
  const titleSplit = new SplitText(".heroTitle", {
    type: "lines",
    linesClass: "lineChild"
  });

  new SplitText(".heroTitle", {
    type: "lines",
    linesClass: "lineParent"
  });

  gsap.from(titleSplit.lines, {
  yPercent: 100, 
  duration: 1,
  opacity: 0,
  ease: "power4.out",
  stagger: 0.15,
  delay: .5
  });

  // Subtitle
  const subtitleSplit = new SplitText(".heroSubtitle", {
    type: "lines",
    linesClass: "lineChild"
  });

  new SplitText(".heroSubtitle", {
    type: "lines",
  });

  gsap.from(subtitleSplit.lines, {
  yPercent: 30,
  opacity: 0,
  duration: .75,
  ease: "power4.out",
  stagger: 0.02,
  delay: .8
  });
});
